import * as React from 'react';
import { Container, Heading } from '@grandvisionhq/elements';
import { ProductBannerView } from '@grandvisionhq/products';

const AlgoliaCrossSellProducts = ({ title , result , formatProductUrl , isLoading , handleImpression , handleInteraction ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "cross-sell-products",
        "data-t": "cross-sell-products"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "medium"
    }, title), /*#__PURE__*/ React.createElement(ProductBannerView, {
        products: result,
        formatProductUrl: formatProductUrl,
        isLoading: isLoading,
        onProductImpression: handleImpression,
        onProductInteraction: handleInteraction
    })));
};
var AlgoliaCrossSellProducts$1 = AlgoliaCrossSellProducts;

export { AlgoliaCrossSellProducts, AlgoliaCrossSellProducts$1 as default };
//# sourceMappingURL=AlgoliaCrossSellProducts.js.map
